import { Component, HostListener, Input, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import * as moment from 'moment';
import { OwlOptions } from 'ngx-owl-carousel-o';
import { Orcamento, Reserva } from 'src/app/model';
import { CalendarioCircuito, CircuitoQuartos, DetalhesCircuitoRQ, Disponibilidade, IdadesCircuito, PaxCircuito, TarifarCircuitoRQ } from 'src/app/model/turismo/circuito.model';
import { CircuitoService, ReservaService } from 'src/app/services';

@Component({
  selector: 'app-circuito-pre-orcamento',
  standalone: false,
  templateUrl: './circuito-pre-orcamento.component.html',
  styleUrl: './circuito-pre-orcamento.component.scss',
})
export class CircuitoPreOrcamentoComponent implements OnInit {
  @Input() Circuito: any;
  @Input() AgenciaId: any;
  @Input() busca: any;
  @Input() Orcamento: Orcamento;

  customOptions: OwlOptions = {
    loop: true,
    mouseDrag: false,
    touchDrag: false,
    pullDrag: false,
    dots: false,
    navSpeed: 700,
    navText: ['', ''],
    responsive: {
        0: {
            items: 1
        },
        400: {
            items: 2
        },
        740: {
            items: 3
        },
        940: {
            items: 4
        }
    },
    nav: true
  }

//   @ViewChild('stepper') stepperComponent: NgbStepperComponent;

@ViewChild('stepper') stepperComponent: any;

  last = false;
  next = false;
  carregando = false;
  podeTarifar = false;

  adicionando = false;
  qntdMax: number = 0;
  qntdMaxFixo: number = 0;

  tarifarCircuitoRQ: TarifarCircuitoRQ = new TarifarCircuitoRQ();
  Meses: CalendarioCircuito = new CalendarioCircuito();
  indexAtual: number = 0;
  today = moment();

  mensagemErro: string;
  Observacoes: string[];
  ServicosInclusos: string[];
  Imagens: string[];

  DisponibilidadeSelecionada: Disponibilidade;
  circuitoTarifado: any;
  circuitoDetalhes: any;

  activeTab = 'daybyday';

  detalhesGroup: FormGroup;
  tarifacaoGroup: FormGroup;
  revisaoGroup: FormGroup;

  stepVisitado = [true, false, false];
  isEditable = true;

  constructor(
    private circuitoService: CircuitoService,
    private reservaService: ReservaService,
    private modalService: NgbModal,
    public _router: Router,
    private _formBuilder: FormBuilder
  ) { }

  ngOnInit() {
    this.tarifarCircuitoRQ = new TarifarCircuitoRQ();
    this.tarifarCircuitoRQ.AgenciaId = this.busca.AgenciaId;
    this.buscarDetalhes();

    if (this.busca.orcamentoId != undefined && this.busca.orcamentoId != null && this.busca.orcamentoId != 0) {
        this.tarifarCircuitoRQ.ReservaId = this.busca.orcamentoId;
        this.tratarAdicionando();
        this.adicionando = true;
    }
    else {
        this.adicionando = false;
    }
    
    this.detalhesGroup = this._formBuilder.group({
        firstCtrl: ['', Validators.required, this.stepVisitado = [true, false, false]]
    });
    this.tarifacaoGroup = this._formBuilder.group({
        firstCtrl: ['', Validators.required, this.stepVisitado = [true, true, false]]
    });
    this.revisaoGroup = this._formBuilder.group({
        firstCtrl: ['', Validators.required, this.stepVisitado = [true, true, true]]
    });
  }

  innerWidth: number = window.innerWidth;
  @HostListener('window:resize', ['$event'])

  onResize() {
    this.innerWidth = window.innerWidth;
  }

  get isMobile() {
    return this.innerWidth < 768;
  }

  buscarDetalhes() {
    delete this.mensagemErro;

    let detalhesCircuitoRQ: DetalhesCircuitoRQ = new DetalhesCircuitoRQ();
    detalhesCircuitoRQ.Circuito = this.Circuito;
    detalhesCircuitoRQ.AgenciaId = this.busca.AgenciaId;
    detalhesCircuitoRQ.DetalhesReserva = false;

    this.circuitoService.detalhesCircuitos(detalhesCircuitoRQ).subscribe(
        dados => {
            this.circuitoDetalhes = dados.Circuito.Detalhes;
            this.Circuito.CidadeInicio = dados.Circuito.CidadeInicio;
            this.Circuito.CidadeFim = dados.Circuito.CidadeFim;
            this.tratarArrayString(dados.Circuito);
            this.tratarDatasCalendario(dados.Circuito);
        },
        (erros) => {
            this.mensagemErro = this.errorHandler(erros, "Buscar Detalhes");
            setTimeout(x => this.modalService.dismissAll(), 2500);
        });
  }

  tratarArrayString(Circuito) {
    try {
        this.Observacoes = Array.from(Circuito.Detalhes.Observacoes);
        this.ServicosInclusos = Array.from(Circuito.Detalhes.ServicosInclusos);
        this.Imagens = Array.from(Circuito.Detalhes.Imagens);
    }
    catch (error) {
        console.log(error);
    }
  }

  transformString(item: String): String {
    if (item != "" && item != undefined) {
        const arr = item.toLowerCase().split(",");
        for (var i = 0; i < arr.length; i++) {
            arr[i] = arr[i].charAt(0).toUpperCase() + arr[i].slice(1);
        }
        return arr.join(", ");
    }
  }

  tratarDatasCalendario(circuito) {
    for (let i = 0; i < this.Meses.Mes.length; i++) {
        this.Meses.Mes[i].Disponibilidades = circuito.Detalhes.Disponibilidades.filter(y => {
            let data = y.Data;
            return moment(data).month() + 1 == this.Meses.Mes[i].Numero;
        })
        if (this.Meses.Mes[i].Disponibilidades.length > 0) {
            this.Meses.Mes[i].Ano = moment(this.Meses.Mes[i].Disponibilidades[0].Data).format("YYYY")
        }
    }
    this.Meses.Mes = this.Meses.Mes.filter(x => x.Disponibilidades.length > 0);
    this.Meses.Mes.sort((a, b) => { return moment(a.Ano).year().valueOf() - moment(b.Ano).year().valueOf() });
  }

  selecionarDisponibilidade(item) {
    this.DisponibilidadeSelecionada = item;
    this.tarifarCircuitoRQ.Data = item.Data;
    this.tarifarCircuitoRQ.CodigoCategoria = item.CategoriaCodigo;
    this.tarifarCircuitoRQ.CategoriaNome = item.CategoriaNome;
    this.tarifarCircuitoRQ.CodigoCircuito = this.Circuito.CodigoCliente;
  }

  fecharModal() {
    this.modalService.dismissAll();
  }

  validaData(data): boolean {
    data = moment(data, 'DDMMYYYY', true);
    let now = moment();
    return data && data.isValid() && data < now && moment(data).isAfter("1900-01-01", 'years');
  }

  tratarAdicionando() {
    this.qntdMax = 0;
    this.busca.quartos.forEach(quarto => {
        this.qntdMax += quarto.qtdeAdultos;
        this.qntdMax += quarto.qtdeCriancas;
        this.qntdMax += quarto.qtdeIdosos;
    });
    this.qntdMaxFixo = this.qntdMax;
  }

  validarTarifacao(): boolean {
    delete this.mensagemErro;

    if (this.adicionando == false) {
        this.tratarTarifacao();
        if (
            this.tarifarCircuitoRQ.PaxSingle.some(x => x.Idade === undefined || x.Idade === null) ||
            this.tarifarCircuitoRQ.PaxDouble.some(x => x.Idade === undefined || x.Idade === null) ||
            this.tarifarCircuitoRQ.PaxTriple.some(x => x.Idade === undefined || x.Idade === null) ||
            this.tarifarCircuitoRQ.PaxShared.some(x => x.Idade === undefined || x.Idade === null) ||
            this.tarifarCircuitoRQ.PaxQuadruple.some(x => x.Idade === undefined || x.Idade === null)
          ) {
            return false;
          }
        else {
            return true;
        }
    }
    else {
        return true;
    }
  }

  bloqueiaSeguir: boolean = true;
  tarifarCircuito() {
      delete this.mensagemErro;
      if (this.tarifarCircuitoRQ.RetarifarCircuito) {
          this.tarifarCircuitoRQ.Circuito = this.circuitoTarifado;
      } else {
          this.circuitoTarifado = undefined;
          this.Circuito.Detalhes = this.circuitoDetalhes;
          this.tarifarCircuitoRQ.Circuito = this.Circuito;
      }

      if (this.validarTarifacao()) {
          this.carregando = true;
          this.circuitoService.tarifarCircuito(this.tarifarCircuitoRQ).subscribe(
              (dados) => {
                  this.circuitoTarifado = dados;
                  if (dados.Erros.length > 0) {
                      this.mensagemErro = dados.Erros.join(",");
                  } else {
                      this.stepperComponent.next();
                  }

                  this.carregando = false;
                  this.tarifarCircuitoRQ.RetarifarCircuito = false;
                  this.bloqueiaSeguir = false;

              },
              (erros) => {
                  console.log(erros);
                  this.carregando = false;
                  this.mensagemErro = this.errorHandler(erros, "Tarifar Circuito");
              });
      } else {
          this.mensagemErro = "Por favor verifique novamente as datas selecionadas, se o problema persistir, entre em contato com o suporte!";
          this.carregando = false;
      }
  }

  alterarQuarto(Tipo: string, Acao: string) {
    if (this.adicionando) {
        this.validarAdicionandoItem(Tipo, Acao);
    } else {
        this.alterarTarifaQuartos(Tipo, Acao);
    }
  }

  validarAdicionandoItem(tipo: string, Acao) {
    switch (tipo) {
        case "Single":
            if (Acao === "Adicionar") {
                this.qntdMax--;
            } else if (Acao === "Remover") {
                this.qntdMax++;
            }
            break;
        case "Shared":
            if (Acao === "Adicionar")
                this.qntdMax--;
            else if (Acao === "Remover")
                this.qntdMax++;
            break;
        case "Double":
            if (Acao === "Adicionar") {
                this.qntdMax = this.qntdMax - 2;
            } else if (Acao === "Remover") {
                this.qntdMax = this.qntdMax + 2;
            }
            break;
        case "Triple":
            if (Acao === "Adicionar") {
                this.qntdMax = this.qntdMax - 3;
            } else if (Acao === "Remover") {
                this.qntdMax = this.qntdMax + 3;
            }
            break;
        case "Quadruple":
            if (Acao === "Adicionar") {
                this.qntdMax = this.qntdMax - 4;
            } else if (Acao === "Remover") {
                this.qntdMax = this.qntdMax + 4;
            }
            break;
    }
  }

  alterarTarifaQuartos(Tipo: string, Acao: string) {
    if (Tipo === "Single" && Acao === "Adicionar") {
        this.tarifarCircuitoRQ.PaxSingle.push(new PaxCircuito());
    } else if (Tipo === "Single" && Acao === "Remover") {
        this.tarifarCircuitoRQ.PaxSingle.pop();
    }

    if (Tipo === "Double" && Acao === "Adicionar") {
        this.tarifarCircuitoRQ.PaxDouble.push(new PaxCircuito());
        this.tarifarCircuitoRQ.PaxDouble.push(new PaxCircuito());
    } else if (Tipo === "Double" && Acao === "Remover") {
        this.tarifarCircuitoRQ.PaxDouble.pop();
        this.tarifarCircuitoRQ.PaxDouble.pop();
    }

    if (Tipo === "Shared" && Acao === "Adicionar") {
        this.tarifarCircuitoRQ.PaxShared.push(new PaxCircuito());
    } else if (Tipo === "Shared" && Acao === "Remover") {
        this.tarifarCircuitoRQ.PaxShared.pop();
    }

    if (Tipo === "Triple" && Acao === "Adicionar") {
        this.tarifarCircuitoRQ.PaxTriple.push(new PaxCircuito());
        this.tarifarCircuitoRQ.PaxTriple.push(new PaxCircuito());
        this.tarifarCircuitoRQ.PaxTriple.push(new PaxCircuito());
    } else if (Tipo === "Triple" && Acao === "Remover") {
        this.tarifarCircuitoRQ.PaxTriple.pop();
        this.tarifarCircuitoRQ.PaxTriple.pop();
        this.tarifarCircuitoRQ.PaxTriple.pop();
    }

    if (Tipo === "Quadruple" && Acao === "Adicionar") {
        this.tarifarCircuitoRQ.PaxQuadruple.push(new PaxCircuito());
        this.tarifarCircuitoRQ.PaxQuadruple.push(new PaxCircuito());
        this.tarifarCircuitoRQ.PaxQuadruple.push(new PaxCircuito());
        this.tarifarCircuitoRQ.PaxQuadruple.push(new PaxCircuito());
    } else if (Tipo === "Quadruple" && Acao === "Remover") {
        this.tarifarCircuitoRQ.PaxQuadruple.pop();
        this.tarifarCircuitoRQ.PaxQuadruple.pop();
        this.tarifarCircuitoRQ.PaxQuadruple.pop();
        this.tarifarCircuitoRQ.PaxQuadruple.pop();
    }
  }

  temTarifa(): boolean {
    if (this.adicionando && this.qntdMax == 0) {
        return true;
    } else if (this.adicionando && this.qntdMax > 0) {
        return false;
    };
    if (this.tarifarCircuitoRQ.PaxSingle.length > 0 ||
        this.tarifarCircuitoRQ.PaxDouble.length > 0 ||
        this.tarifarCircuitoRQ.PaxShared.length > 0 ||
        this.tarifarCircuitoRQ.PaxTriple.length > 0 ||
        this.tarifarCircuitoRQ.PaxQuadruple.length > 0) {
        return true;
    }
    else {
        return false;
    };
  }

  tratarTarifacao() {
    this.Circuito.CircuitoQuartos = new CircuitoQuartos();
    let i = 0;
    let quarto = 0;
    this.tarifarCircuitoRQ.PaxSingle.forEach(x => {
        this.Circuito.CircuitoQuartos.PaxSingle[i] = new IdadesCircuito();
        this.Circuito.CircuitoQuartos.PaxSingle[i].Idades.push(x.Idade);
        i++;
    });
    quarto = 0, i = 0;
    this.tarifarCircuitoRQ.PaxDouble.forEach(x => {
        i === 0 ? this.Circuito.CircuitoQuartos.PaxDouble.push(new IdadesCircuito()) : true;
        this.Circuito.CircuitoQuartos.PaxDouble[quarto].Idades.push(x.Idade);
        if (i === 1) {
            i = 0;
            quarto++;
        } else
            i++;
    });
    quarto = 0, i = 0;
    this.tarifarCircuitoRQ.PaxShared.forEach(x => {
        i === 0 ? this.Circuito.CircuitoQuartos.PaxShared.push(new IdadesCircuito()) : true;
        this.Circuito.CircuitoQuartos.PaxShared[quarto].Idades.push(x.Idade);
        if (i === 1) {
            i = 0;
            quarto++;
        } else
            i++;
    });
    quarto = 0, i = 0;
    this.tarifarCircuitoRQ.PaxTriple.forEach(x => {
        i == 0 ? this.Circuito.CircuitoQuartos.PaxTriple.push(new IdadesCircuito()) : true;
        this.Circuito.CircuitoQuartos.PaxTriple[quarto].Idades.push(x.Idade);
        if (i === 2) {
            i = 0;
            quarto++;
        } else
            i++;
    });
    quarto = 0, i = 0;
    this.tarifarCircuitoRQ.PaxQuadruple.forEach(x => {
        i == 0 ? this.Circuito.CircuitoQuartos.PaxQuadruple.push(new IdadesCircuito()) : true;
        this.Circuito.CircuitoQuartos.PaxQuadruple[quarto].Idades.push(x.Idade);
        if (i === 3) {
            i = 0;
            quarto++;
        } else
            i++;
    });
  }

  public errorHandler(erro, acao: string = null): string {
    let mensagem = 'Erro';
    if (acao !== null) {
        mensagem += ' ao tentar ' + acao + ': ';
    }
    switch (erro.status) {
        case 0: mensagem += 'o servidor não respondeu, tente novamente mais tarde!'; break;
        case 401: mensagem += 'você não tem autorização para executar esta ação!'; break;
        case 406: mensagem += 'a requisição não foi aceita, tente novamente!'; break;
        case 500: mensagem += 'Houve um erro interno no servidor! tente novamente, caso o erro persista, entre em contato com o suporte'; break;
        default: mensagem += erro.statusText; break;
    }
    return mensagem + '/' + erro.error.mensagem;
  }

  salvarOrcamento() {
    delete this.mensagemErro;
    this.circuitoTarifado.Id = null;
    this.Orcamento.Circuitos[0] = this.circuitoTarifado;

    this.Orcamento.quartos = this.busca.quartos;
    this.Orcamento.AgenciaId = this.busca.AgenciaId;

    if (this.busca.novoOrcamento) {
        this.reservaService.salvarOrcamento(this.Orcamento as unknown as Reserva).subscribe(
            dados => {
                window.sessionStorage.removeItem("orcamentousuario");
                this.modalService.dismissAll();
                this._router.navigate([`/orcamento/${dados.Id}`]);
            },
            erros => {
                console.log(erros);
                this.mensagemErro = this.errorHandler(erros, "Gerar Reserva")
            }
        );
    }
    else {
        this.reservaService
            .adicionarItemOrcamento(this.Orcamento as unknown as Reserva, this.busca.orcamentoId)
            .subscribe(
                dados => {
                    window.sessionStorage.removeItem("orcamentousuario");
                    this._router.navigate([`/orcamento/${this.busca.orcamentoId}`]);
                },
                erros => {
                    console.log(erros);
                    this.mensagemErro = this.errorHandler(erros, "Adicionar Circuito");
                }
            );
    }
  }

  quartoSelecionado: string = '';
  selecionouQuarto(event: any) {
      var quartoSelecionado = this.circuitoTarifado.SelecaoQuartos.find(quarto => quarto.Codigo === event);

      this.circuitoTarifado.Extra = quartoSelecionado.Codigo;
      this.circuitoTarifado.ValorNet = quartoSelecionado.ValorQuarto;
      this.circuitoTarifado.ValorVenda = quartoSelecionado.ValorQuarto;

      this.tarifarCircuitoRQ.RetarifarCircuito = true;
      this.tarifarCircuito();
  }

  trackByCodigo(index: number, quarto: any): number {
      return quarto.CodigoQuarto;
  }
}
